<template>
  <div class="content">
    <NavbarShowcase />
    <v-main>
      <v-container fluid>
        <div class="showcase-content">
          <v-card class="sc-aside bg-white">
            <v-card-title>
              Registros Eventos
            </v-card-title>
            <v-card-subtitle>
              Fecha límite de inscripción: {{ filter.formatDate(event.date_inscription, 1) }}
            </v-card-subtitle>
            <v-card-text>
              <div class="text-overline font-weight-light">Evento</div>
              <div>{{ event.name }}</div>
              <div class="text-overline font-weight-light mt-3">Objetivo</div>
              <div v-html="event.objective"></div>
              <div class="text-overline font-weight-light mt-3">Descripción</div>
              <div v-html="event.description"></div>
              <div class="text-overline font-weight-light mt-3">Aliados</div>
              <div>
                <div v-if="allie">
                  <div class="allies">
                    <v-sheet class="allie-cover d-flex align-center justify-center" v-for="(item, index) in allie" :key="index">
                      <v-img :src="params.host+'/dovim/uploads/images/aliados/'+item.logo" max-width="150" />
                    </v-sheet>
                  </div>
                </div>
                <div v-else>
                  Ningún aliado asignado.
                </div>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="sc-section bg-white">
            <v-card-title>
              <div>Proceso Inscripción {{ step }} de 3
                <v-progress-linear :model-value="progress" color="amber" :height="12"></v-progress-linear></div>
            </v-card-title>
            <v-card-text>
              <div>
                <v-window v-model="step">
                  <v-window-item :key="1" :value="1">
                    <div class="d-flex flex-column">
                      <div class="text-overline font-weight-medium">Validar Número de Documento</div>
                      <div class="text-caption">Por favor ingresa tu número de documento para validar si ya te encuentras registrado en el sistema.</div>
                      <v-text-field
                      v-model="participant.documento"
                      variant="outlined" density="compact" 
                      placeholder="Número de documento (Este campo solo acepta números)" 
                      onkeypress="return event.charCode>=48 && event.charCode<=57"
                      :error-messages="v1$.documento.$errors.map(e => e.$message)"/>
                      <div class="text-right">
                        <v-btn color="primary" variant="flat" :loading="loading" @click="validate()" >
                          Validar
                        </v-btn>
                      </div>
                    </div>
                  </v-window-item>
                  <v-window-item :key="2" :value="2">
                    <div class="d-flex flex-column">
                      <div class="text-overline font-weight-medium">Registro</div>
                      <div class="text-caption">Completa los siguientes datos personales.</div>
                      <div class="data-input-content my-3">
                        <v-text-field class="data-input" v-model="participant.nombres" variant="outlined" density="compact" label="Nombres"
                        :error-messages="v2$.nombres.$errors.map(e => e.$message)"/>
                        <v-text-field class="data-input" v-model="participant.apellidos" variant="outlined" density="compact" label="Apellidos" 
                        :error-messages="v2$.apellidos.$errors.map(e => e.$message)"/>
                        <v-text-field class="data-input" v-model="participant.correo_principal" variant="outlined" density="compact" label="Correo electrónico principal" 
                        :error-messages="v2$.correo_principal.$errors.map(e => e.$message)"/>
                        <v-text-field class="data-input" v-model="participant.contacto_principal" variant="outlined" density="compact" label="Número de contacto principal" 
                        onkeypress="return event.charCode>=48 && event.charCode<=57"
                        :error-messages="v2$.contacto_principal.$errors.map(e => e.$message)"/>
                        
                        <v-select class="data-input" v-model="participant.pais" variant="outlined" 
                        density="compact" label="País donde vives actualmente" prepend-icon="mdi-help-circle-outline"
                        :items="country" item-title="label" item-value="value" 
                        :error-messages="v2$.pais.$errors.map(e => e.$message)"
                        @update:modelValue="changeCountry()"/>
                        
                        <v-select class="data-input" v-model="participant.departamento" variant="outlined" density="compact" label="Departamento donde vives actualmente" 
                        :items="department" item-value="value" item-title="label" 
                        :disabled="participant.pais !== 'Colombia'"
                        :error-messages="v2$.departamento.$errors.map(e => e.$message)"
                        @update:model-value="changeDepartment()"/>
                        
                        <v-select class="data-input" v-model="participant.ciudad" variant="outlined" density="compact" label="Ciudad donde vives actualmente" 
                        :items="city" item-value="value" item-title="label"
                        :disabled="participant.pais !== 'Colombia'" 
                        :error-messages="v2$.ciudad.$errors.map(e => e.$message)"/>

                        <v-select class="data-input" v-model="participant.ubicacion_institucion" variant="outlined" density="compact" label="Zona de la entidad donde estás vinculado" 
                        :items="location" item-value="value" item-title="label"
                        :error-messages="v2$.ubicacion_institucion.$errors.map(e => e.$message)"/>

                        <v-select class="data-input" v-model="participant.edad" variant="outlined" density="compact" label="Rango de edad" 
                        :items="ages" item-value="value" item-title="label"
                        @update:modelValue="changeRole()"
                        :error-messages="v2$.edad.$errors.map(e => e.$message)"/>

                        <v-select class="data-input" v-model="participant.cargo" variant="outlined" density="compact" label="Rol o Eres" 
                        :items="roles" item-value="value" item-title="label" 
                        @update:modelValue="changeTrayectory()"
                        :error-messages="v2$.cargo.$errors.map(e => e.$message)"/>

                        <v-select class="data-input" v-model="participant.trayectoria" variant="outlined" density="compact" label="Trayectoria en el cargo" 
                        :items="trajectory" item-value="value" item-title="label"
                        :error-messages="v2$.trayectoria.$errors.map(e => e.$message)"/>

                        <v-select class="data-input" v-model="participant.formacion" variant="outlined" density="compact" label="Último nivel de formación alcanzado" 
                        :items="formation" item-value="value" item-title="label" 
                        :error-messages="v2$.formacion.$errors.map(e => e.$message)"/>

                        <v-select class="data-input" v-model="participant.genero" variant="outlined" density="compact" label="Sexo de nacimiento" 
                        :items="gender" item-value="value" item-title="label"
                        :error-messages="v2$.genero.$errors.map(e => e.$message)"/>
                      </div>
                      <div class="text-right">
                        <v-btn variant="flat" color="primary" @click="register()" :loading="loading">Registrarme</v-btn>
                      </div>
                    </div>
                  </v-window-item>
                  <v-window-item :key="3" :value="3">
                    <div>
                      <div class="text-overline font-weight-medium">Política de tratamiento de datos</div>
                      <div>
                        Al realizar esta inscripción Autorizo a <b>United Way Colombia</b> a realizar toma de fotografías, vídeos o entrevistas en las que aparezco y cedo el uso de mi imagen y registro de las actividades en las cuales participé, para los fines contemplas en la <a target="_blank" href="https://unitedwaycolombia.org/wp-content/uploads/2024/12/Politica_tratamientio_de_datos_2025.pdf">Política de Tratamiento de Datos</a> de dicha entidad, en la cual se incluyen, entre otras, la realización de piezas de comunicación interna y externa. Como titular de los datos, podré en cualquier momento, solicitar que la información sea modificada, actualizada o retirada de las bases de datos de <a target="_blank" href="https://unitedwaycolombia.org/">United Way Colombia</a>.
                      </div>
                    </div>
                    <div>
                      <div class="text-overline font-weight-medium">Política de comunicaciones</div>
                      <div>
                        Autorizo el envío de correspondencia, correos electrónicos, comunicados, boletines virtuales, contacto telefónico o cualquier otro método con el fin de realizar actividades publicitarias, promocionales, de mercadeo, de divulgación de información educativa o misional de la Fundación, estudios de mercado o para la comunicación de las soluciones o campañas en pro de la educación. Podrás ajustar estos permisos desde tu perfil de beneficiario pasadas 24 horas de tu registro.
                      </div>
                    </div>
                    <div>
                      <div class="text-overline font-weight-medium">Confirmar inscripción a evento</div>
                      <v-checkbox v-model="accepted">
                        <template v-slot:label>
                          <div>Confirmo que he leído las políticas de privacidad y tratamiento de datos personales, así como mi deseo de inscribirme y participar de este evento.</div>
                        </template>
                      </v-checkbox>
                    </div>
                    <div class="text-right">
                      <v-btn variant="flat" color="primary" @click="confirm()" :loading="loading" :disabled="!accepted">Confirmar mi inscripción</v-btn>
                    </div>
                  </v-window-item>
                  
                </v-window>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-container>
    </v-main>
    <!-- success -->
    <v-dialog v-model="success.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">Registro Eventos</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>      
      </v-sheet>
    </v-dialog>

    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">Registro Eventos</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
      </v-sheet>
    </v-dialog>

    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
  </div>
</template>
<script setup>
  import NavbarShowcase from '../components/navbar/NavbarShowcase';
  import axios from 'axios';
  import Params from '@/models/params';
  import Participant from '@/models/participant';
  import Convocatory from '@/models/convocatory';
  import Filters from '@/models/filters';
  import { ref, reactive, computed, onMounted } from "vue";
  import { useRoute } from 'vue-router';
  import { useVuelidate } from '@vuelidate/core';
  import { required, numeric, minLength, maxLength, minValue, maxValue, email, helpers } from '@vuelidate/validators';
  import moment from 'moment';

  const route = useRoute();
  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const participant = reactive(new Participant)
  const params = ref(new Params)
  const event = reactive(new Convocatory)
  const filter = ref(new Filters)
  const accepted = ref(false)

  const progress = ref(33)
  const step = ref(1)
  const loading = ref(false)  
  const process = ref(true)
  const token = ref(null);

  const gender = ref(params.value.gender)
  const location = ref(params.value.location)
  const country = ref(params.value.country)
  const department = ref([])
  const city = ref([])
  const formation = ref([])
  const ages = ref([])
  const roles = ref([])
  const trajectory = ref([])
  const allie = ref([])

  event.code = route.params.code;

  const rulesStepOne = computed(() => {
    return {
      documento: { 
        required: helpers.withMessage('Campo requerido.', required), 
        numeric: helpers.withMessage('Solo números.', numeric), 
        minLength: helpers.withMessage('Mínimo 6 números.', minLength(5)), 
        maxLength: helpers.withMessage('Máximo 15 números.', maxLength(15)), 
      }
    }
  })

  const rulesSteoTwo = computed(() => {
    return {
      nombres: { required: helpers.withMessage('Campo requerido.', required) },
      apellidos: { required: helpers.withMessage('Campo requerido.', required) },
      correo_principal: { 
        required: helpers.withMessage('Campo requerido.', required),
        email: helpers.withMessage('Formato inválido.', email)
      },
      contacto_principal: {
        required: helpers.withMessage('Campo requerido.', required),
        numeric: helpers.withMessage('Solo números.', numeric),
        minLength: helpers.withMessage('Mínimo 7 números.', minLength(7)), 
        maxLength: helpers.withMessage('Máximo 10 números.', maxLength(10)), 
      },
      pais: { required: helpers.withMessage('Campo requerido.', required) },
      departamento: { required: helpers.withMessage('Campo requerido.', required) },
      ciudad: { required: helpers.withMessage('Campo requerido.', required) },
      ubicacion_institucion: { required: helpers.withMessage('Campo requerido.', required) },
      cargo: { required: helpers.withMessage('Campo requerido.', required) },
      trayectoria: { required: helpers.withMessage('Campo requerido.', required) },
      formacion: { required: helpers.withMessage('Campo requerido.', required) },
      edad: { required: helpers.withMessage('Campo requerido.', required) },
      genero: { required: helpers.withMessage('Campo requerido.', required) },
      migrantes: { 
        required: helpers.withMessage('Campo requerido.', required),
        numeric: helpers.withMessage('Solo números.', numeric),
        minValue: helpers.withMessage('Solo valores entre 0 y 100.', minValue(0)), 
        maxValue: helpers.withMessage('Solo valores entre 0 y 100.', maxValue(100)), 
      },
    }
  })

  const v1$ = useVuelidate(rulesStepOne, participant)
  const v2$ = useVuelidate(rulesSteoTwo, participant)

  async function load(){
    department.value = await params.value.department()
    formation.value = await params.value.formation()
    ages.value = await params.value.age()
    roles.value = await params.value.roles()
    const frm = new FormData;
    frm.append('action','cargar');
    frm.append('value', event.code);
    const result = await eject(frm);
    process.value = false;
    if(result.state){
      event.name = result.data[0].convocatoria;
      event.program = result.data[0].idprograma;
      event.group = result.data[0].grupo;
      event.objective = result.data[0].competencias;
      event.description = result.data[0].descripcion;
      event.date_inscription = result.data[0].inscripcion;
      event.date_begin = result.data[0].desde;
      event.quota = result.data[0].cupo;
      event.request = result.data[0].solicitudes;
      
      if(moment().diff(moment(event.date_inscription),'days') > 0){
        error.text = "La fecha de inscripción se encuentra cerrada."
        error.state = true;
      }

      if(event.quota <= event.request){
        error.text = "El cupo dispuesto para este evento se ha llenado, por favor te invitamos a participar en una próxima ocasión."
        error.state = true;
      }
    }else{
      error.text = "Ha ocurrido un error al cargar los datos del evento, por favor intenta más tarde."
      error.state = true;
    }
  }

  async function allies(){
    const frm = new FormData;
		frm.append("action", "aliados");
    frm.append("value", event.code);
    const result = await eject(frm);
    if(result.state){
      allie.value = result.data;
    }
  }

  async function validate(){
    if(!await v1$.value.$validate()){
      return
    }
    loading.value = true;
    const frm = new FormData;
		frm.append("action", "validar");
    frm.append("document", participant.documento);
    frm.append("group", event.group);
    const result = await eject(frm);
    loading.value = false;
    if(result.state){
      token.value = result.token;
      if(!result.data[0].inscripcion){
        step.value = 2;
        progress.value = 66;
      }else if(result.data[0].solicitud == 0){
        step.value = 3;
        progress.value = 100;
      }else{
        success.text = "El número de documento, ya se encuentra inscrito en este evento.";
        success.state = true;
      }
    }
  }

  async function register(){
    if(!await v2$.value.$validate()){
      return
    }
    if(!participant.documento){
      error.text = "No se ha encontrado el número de documento por favor recarga la página y vuelve a registrarte."
      error.state = true;
    }
    /*let ipnum = null;
    await fetch('https://api.ipify.org?format=json')
    .then(x => x.json())
    .then(({ ip }) => {
      ipnum = ip;
    });*/
    loading.value = true;
    const frm = new FormData;
    frm.append("action","inscribir");
    frm.append("program", event.program);
    frm.append("group", event.group);
    frm.append("data", JSON.stringify(participant));
    frm.append("token",token.value);
    const result = await eject(frm);
    loading.value = false;
    if(result.state){
      step.value = 3;
      progress.value = 100;
    }else{
      error.text = "Ha ocurrido un error al intentar registrar tus datos, por favor intenta más tarde."
      error.state = true;
    }
    
  }

  async function confirm(){
    loading.value = true;
    const frm = new FormData;
    frm.append("action", "confirmacion");
    frm.append("event", event.code);
    frm.append("group", event.group);
    frm.append("document", participant.documento);
    const result = await eject(frm);
    loading.value = false;
    if(result.inscripcion){
      success.text = result.message;
      success.state = true;
    }else{
      error.text = result.message;
      error.state = true;
    }
  }

  //Auxiliar

  async function changeRole(){
    participant.trayectoria = null
    participant.formacion = null
    participant.cargo = null
    roles.value = await params.value.roles(participant.edad)
  }

  async function changeTrayectory() {
    trajectory.value = await params.value.trajectory(participant.cargo, participant.edad)
    formation.value = await params.value.formation(participant.edad)
  }

  async function changeCountry(){
    if(participant.pais !== 'Colombia'){
      participant.departamento = 100;
      participant.ciudad = 99998;
      participant.id_institucion = 1;
      city.value = await params.value.city(participant.departamento);
    }else{
      participant.departamento = null;
      participant.ciudad = null;
      participant.tipo_institucion = null;
      participant.id_institucion = null;
    }
  }

  async function changeDepartment(){
    participant.ciudad = null;
    city.value = await params.value.city(participant.departamento);
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'evento.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(()=>{
    load();
    allies();
  })

</script>